<template>
	<div class="main" v-loading="list_loading">
		<el-row class="add-btn"><el-button type="primary" style="margin-right:40px;" @click="add_service = true">添加</el-button></el-row>
		<el-table :data="dataList" border style="width: 100%">
			<el-table-column prop="id" label="id"></el-table-column>
			<el-table-column prop="type" label="类型"></el-table-column>
			<el-table-column prop="label" label="标签"></el-table-column>
			<el-table-column prop="value" label="值"></el-table-column>
			<el-table-column prop="description" label="描述"></el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<el-button size="mini" type="warning" @click="handleEdit(scope.row)" icon="el-icon-edit">编辑</el-button>
					<el-button size="mini" type="danger" @click="handleDelete(scope.row)" icon="el-icon-delete">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="block">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				background
				@size-change="handleSizeChange"
				:page-sizes="[5, 10, 20]"
				:page-size="pageSize"
				layout="sizes,prev, pager, next,total,jumper"
				:total="total"
			></el-pagination>
		</div>
		<!-- 添加字典列表 -->
		<el-dialog title="添加字典" :visible.sync="add_service" width="30%" @close="clearAddModel">
			<add-diction ref="addForm"></add-diction>
			<span slot="footer" class="dialog-footer">
				<el-button @click="add_service = false">取 消</el-button>
				<el-button type="primary" @click="addUser1">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑字典列表 -->
		<el-dialog title="编辑字典" :visible.sync="edit_service" width="30%">
			<edit-diction ref="editForm"></edit-diction>
			<span slot="footer" class="dialog-footer">
				<el-button @click="edit_service = false">取 消</el-button>
				<el-button type="primary" @click="addUser">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import addDiction from './add_diction.vue';
import editDiction from './edit_diction.vue';
export default {
	components: {
		addDiction,
		editDiction
	},
	data() {
		return {
			total: 0, //总页数
			pageSize: 10, //每页条数
			currentPage: 1, //当前页（默认第一页）
			dataList: [],
			list_loading: false,
			add_service: false,
			edit_service:false
		};
	},
	created() {
		this.getList();
	},
	mounted() {
		//判断子组件传的数（弹框关闭）
		this.$bus.$on('isLook', val => {
			this.admin_dv = val;
		});
	},
	methods: {
		handleCurrentChange(val) {
			this.currentPage = val; //获取当前页
			this.getList();
		},
		handleSizeChange(psize) {
			//选择每页条数
			this.pageSize = psize;
			this.getList();
		},
		// 字典列表
		getList() {
			let data = new FormData();
			data.append('length', this.pageSize);
			data.append('page', this.currentPage);
			
			// let data = {
			// 	length: this.pageSize,
			// 	page: this.currentPage
			// 	// name:"",
			// 	// idcardno:"",
			// 	// mobile:"",
			// };
			this.$post('api/dict/listData', data)
				.then(res => {
					this.dataList = res.data.list;
					this.total = res.data.total;
					this.list_loading = false;
				})
				.catch(e => {
					window.console.log(e);
				});
		},
		//添加
		addUser1() {
			this.$refs.addForm.$refs.frmAdd.validate(valid => {
				if (valid) {
					let data = new FormData();
					data.append('type', this.$refs.addForm.form.type);
					data.append('label', this.$refs.addForm.form.label);
					data.append('value', this.$refs.addForm.form.value);
					data.append('description', this.$refs.addForm.form.description);
					this.$post('api/dict/save', data)
						.then(res => {
							window.console.log(res);
							if (res.success == 1) {
								this.$message({
									message: res.message,
									type: 'success'
								});
								this.getList();
							} else {
								this.$message({
									message: res.message,
									type: 'error'
								});
							}
							this.add_service = false;
						})
						.catch(e => {
							window.console.log(e);
						});
				} else {
					return this.$message({
						message: '请完整填写信息！',
						type: 'warn'
					});
				}
			});
		},
		clearAddModel() {
			//返回时清空表单数据
			this.$refs.addForm.form = {
				type: '',
				label:"",
				value:"",
				description:""
			};
		},
		//编辑
		handleEdit(row) { 
			this.edit_service = true
			window.console.log(row)
			this.$nextTick(() => {//不用走接口获取table里的内容
				this.$refs.editForm.form = Object.assign({}, row);
			});
		
		},
		//编辑确定
		addUser() {
			this.$refs.editForm.$refs.frmAdd.validate((valid) => {
				if (valid) {
					let data = new FormData();
					data.append('id', this.$refs.editForm.form.id);
					data.append('type', this.$refs.editForm.form.type);
					data.append('label', this.$refs.editForm.form.label);
					data.append('value', this.$refs.editForm.form.value);
					data.append('description', this.$refs.editForm.form.description);
					
					this.$post("api/dict/update", data).then(res => {
						window.console.log(res)
						if (res.success == 1) {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getList()
						} else {
							this.$message({
								message: res.message,
								type: 'error'
							});
						}
						this.edit_service = false
					}).catch((e) => {
						window.console.log(e)
					})
		
				} else {
					return this.$message({
						message: '请完整填写信息！',
						type: 'warn'
					})
				}
			})
		},
		//删除
		handleDelete(row) { 
		// let data=new FormData();
		// data.append('id',row.id);
		
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post("api/dict/"+row.id+"/delete/").then(res => {
					let totalPage = Math.ceil((this.total - 1) / this.pageSize)
					let currentPage = this.currentPage > totalPage ? totalPage : this.currentPage
					this.currentPage = currentPage < 1 ? 1 : currentPage
					if (res.success == 1) {
						this.$message({
							type: 'success',
							message: res.message
						});
						this.getList()
					}else{
						this.$message({
							type: 'error',
							message: res.message
						});
					}
				}).catch((e) => {
					window.console.log(e)
				})
		
			})
		},
		
	}
};
</script>

<style scoped="scoped">
.main .block {
	text-align: center;
	margin-top: 20px;
}

.main {
	background: #fff;
	padding: 0 20px 20px 20px;
}
.add-btn {
	padding-top:20px;
	margin-bottom: 20px;
}

.add-btn .el-button {
	font-size: 16px;
}
</style>
